import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { IoIosClose } from 'react-icons/io';

const ModalHeader = ({
  title,
  Icon,
  onClose,
  titleClass = '',
  titleStyle = '',
  iconStyle = '',
  isMailModal = false,
  classCondition = false,
  RightButtonType,
  RightButtonOnClick,
}) => {
  return (
    <div
      className={`${classCondition ? 'commit-title' : 'flex-container'}${titleClass ? ' ' + titleClass : ''}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="left-content">
        {Icon ? (
          <div className={`icon-wrapper ${iconStyle}`}>{Icon}</div>
        ) : null}
        {!isMailModal && <div className={`title2 ${titleStyle}`}>{title}</div>}
      </div>
      <div className="right-content">
        {RightButtonType && (
          <IconButton
            type={RightButtonType}
            onClick={RightButtonOnClick}
            disabled={!RightButtonOnClick} // Use disabled instead of isDisable
          />
        )}
      </div>
      <IoIosClose className="delete-close" onClick={onClose} />
    </div>
  );
};

ModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  Icon: PropTypes.element,
  onClose: PropTypes.func.isRequired,
  titleClass: PropTypes.string,
  titleStyle: PropTypes.string,
  iconStyle: PropTypes.string,
  isMailModal: PropTypes.bool,
  classCondition: PropTypes.bool,
  RightButtonType: PropTypes.string,
  RightButtonOnClick: PropTypes.func,
};

export default ModalHeader;
